const TOKEN_CANDIDATE_KEYS = ["accessToken", "AccessToken", "token", "Token"];

export const pickToken = (data) => {
    if (typeof data === "string") {
        return data || null;
    }

    if (!data || typeof data !== "object") return null;

    for (const key of TOKEN_CANDIDATE_KEYS) {
        if (data[key]) return data[key];
    }

    const nested = data?.data;
    if (nested && typeof nested === "object") {
        for (const key of TOKEN_CANDIDATE_KEYS) {
            if (nested[key]) return nested[key];
        }
    }

    return null;
};

export const extractLoginTokens = ({ identityResult, rpcResult }) => ({
    bearerToken: pickToken(identityResult),
    rpcToken: pickToken(rpcResult),
});
